import React, { Component, Fragment } from 'react';
import Section from './Section.js'
import {reduxForm, Field, formValueSelector} from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import {FormattedHTMLMessage} from 'react-intl';
import generateValidator from './Validations/generateValidator';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import SaveStepButton from './SaveStepButton';
import withAuthControl from '../auth/Auth.js';
import AttributeOptions from './AttributeOptions.js';
import { WAButton } from './Button.js';

class GuarantorForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false,
            resources: [
                'guarantor_type'
            ]
        };
    }

    render() {
        const { handleSubmit, submitting, error, guarantorTypeTypeSelected } = this.props;
        const guarantor_type = [{id: 0, name: 'Garante propietario'},{id: 1, name: 'Garante con bono de sueldo'}];
        const guarantor = (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                        <AttributeOptions name="guarantor_type" defaultValue="Tipo de Garante" label="Tipo de Garante" attributeName='guarantor_type' attributeOptions={guarantor_type} />
                    </div>
                </div>
            </div>
        );

        return (
            <Section className="intro_form">
            <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_guarantor" description="Type Guarantor"/>
                    <div className="show-desktop">
                        <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                        <SaveStepButton/>
                    </div>
                </div>
                <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                    {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' /> }
                        <div>
                            <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                                {error && <CustomAlert bsStyle="danger" message={error}/>}
                                    {guarantor}
                                    {guarantorTypeTypeSelected === '1' && <FormattedHTMLMessage id="app.step_guarantor_type_bond" description="Investment"/>}
                                <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Continuar</button>
                            </form>
                        </div>
                        <div className="show-mobile">
                            <WAButton phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                </div>
            </div>
        </Section>
        );
    }
}

GuarantorForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}
const selector = formValueSelector('GuarantorForm')

let validate = generateValidator([{name: 'guarantor_type', required: true}]);

GuarantorForm = connect(
    state => {
        const guarantorTypeTypeSelected = selector(state, 'guarantor_type')
        return {
            guarantorTypeTypeSelected
        }
    }
)(GuarantorForm)

GuarantorForm = reduxForm({
    form: 'GuarantorForm', // a unique name for this form
    validate,
})(GuarantorForm);

GuarantorForm = withRouter(GuarantorForm);

GuarantorForm = withAuthControl(GuarantorForm);

export default GuarantorForm;



/** WEBPACK FOOTER **
 ** ./src/components/GuarantorForm.js
 **/